import React from 'react';

import { useParams } from 'react-router-dom';

import {
    CustomTableColumnsModal,
    ICustomTableColumnsModal,
} from 'components/common/Modals/CustomTableColumns/customTableColumnsModal';

import { WidgetButton } from 'components/Dashboards/Reporting/_common/widgetButtons/WidgetButton';

interface ReportUrlParams {
    widgetId?: string;
}

interface Props extends ICustomTableColumnsModal {
    onOpenModal: () => void;
}

export const ColumnsManager = ({
    showModal,
    onHideModal,
    widgetId,
    componentKey,
    tableInstance,
    initialState,
    columns,
    onChangeVisibility,
    onChangeOrder,
    onOpenModal,
    widgetViewMode,
}: Props) => {
    // If widgetId is not provided via props, get it from the URL params in edit report mode
    const { widgetId: widgetIdUrlParam } = useParams<ReportUrlParams>();
    return (
        <>
            <WidgetButton icon={'tune-filter'} onClick={onOpenModal} tooltipContent={'Customize table columns'} />
            <CustomTableColumnsModal
                onHideModal={onHideModal}
                showModal={showModal}
                widgetId={widgetId ?? widgetIdUrlParam}
                componentKey={componentKey}
                tableInstance={tableInstance}
                initialState={initialState}
                columns={columns}
                onChangeVisibility={onChangeVisibility}
                onChangeOrder={onChangeOrder}
                widgetViewMode={widgetViewMode}
            />
        </>
    );
};
